import { useState, useRef, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import authApi from "../api/authApi";
import { Link } from "react-router-dom";
import schoolApi from "../api/schoolApi";
import * as constants from "../constants/CONSTANT";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// saved path is "uploads/<schema>/<userid>/<file>" (served by the backend at /uploads)
const imageUrl = (p) => {
  if (!p) return "";
  if (/^(https?:|data:|blob:)/i.test(p)) return p;
  return "/" + String(p).replace(/^\/+/, "");
};
// same path on the backend host (frontend and backend on different ports / domains)
const backendImageUrl = (p) => {
  try {
    const origin = new URL(constants.API_BASE_URL, window.location.origin).origin;
    return origin + imageUrl(p);
  } catch (e) {
    return "";
  }
};

const Profile = (props) => {
  const token = localStorage.getItem("token");
  const fileInputRef = useRef();
  const [image, setImage] = useState("");
  const [file, setFile] = useState(null);
  const [profile, setProfile] = useState({});
  const [body, setBody] = useState();
  const [show, setShow] = useState(false);
  const [user, setUser] = useState({ password: "", confirmpassword: "" });
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [oldPassword, setOldPassword] = useState(null);
  const [checkOldPassword, setCheckOldPassword] = useState(null);
  const [checkPassword, setCheckPassword] = useState(true);
  const [passwordInputDisabled, setPasswordInputDisabled] = useState({
    password: true,
    confirmPassword: true,
  });
  const [passwordError, setPasswordError] = useState("");
  const [emailError, setEmailError] = useState("");
  

  useEffect(() => {
    var dataImage = localStorage.getItem("myimage");
    let bannerImg = document.getElementById("profile-image");
    if (localStorage.getItem("myimage") !== "/img_avatar.png") {
    } else {
      bannerImg.src = localStorage.getItem("myimage");
      
    }
  }, [localStorage.getItem("myimage")]);

  useEffect(() => {
    async function init() {
      let result = await schoolApi.getLoginUserData();
      console.log('result-user->',result);
      if (result.success) {
        const raw = result?.userRec?.profile_image;
        setImage(imageUrl(raw));
        // load through the files API (works whatever host / port serves /uploads)
        const fileId = String(raw || "").split("/").pop().split(".")[0];
        if (/^[0-9a-f-]{36}$/i.test(fileId)) {
          try {
            const blob = await schoolApi.downloadFiles(fileId);
            if (blob && blob.size) setImage(URL.createObjectURL(blob));
          } catch (e) {
            console.error("profile image load failed", e);
          }
        }
        setProfile(result?.userRec);
      }
    }

    init();
  }, []);

  const handlePasswordOnchange = (e) => {
    const trimmedValue = e.target.value.replace(/\s/g, "");
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    const isValidPassword = passwordRegex.test(trimmedValue);
    setUser({
      ...user,
      [e.target.name]: trimmedValue,
    });
    if (!isValidPassword) {
      setPasswordError("Password must be 8+ chars with A-Z, a-z, 0-9 & special char.");
    } else {
      setPasswordError(""); // Clear error if valid
    }
    setCheckPassword(true);
  };

  const handleChange = (e) => {

    if(e.target.name==='email'){

   
    if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(e.target.value)
    ) {
      if (e.target.value === "") {
        setEmailError("");
      } else setEmailError("Invalid email format");
    } else {
      setEmailError(""); // Clear the error if valid
    }
  }
    if (e.target.name === "phone") {
      const inputPhone = e.target.value.replace(/\D/g, "").slice(0, 10);
      setProfile({ ...profile, [e.target.name]: inputPhone });
    } else {
      setProfile({ ...profile, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if(emailError){
      return 
    }

    if (profile?.phone) {
      if (profile?.phone.length !== 10) {
        toast.error("Enter a valid 10-digit phone number.");
        return;
      }
    }

    if (profile?.firstname === "") {
      return toast.error("Please Enter First name");
    }
    if (profile?.lastname === "") {
      return toast.error("Please Enter Lastname ");
    }
    if (profile?.email === "") {
      return toast.error("Please Enter email ");
    }
    if (profile.email) {
      let emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
      if (!emailRegex.test(profile.email)) {
        toast.error("Enter valid Email!!!");
        return;
      }
    }
    if (profile?.phone === "") {
      return toast.error("Please Enter phone no..");
    }

    let result = {};
    if (selectedFiles === null) {
      result = await schoolApi.saveUser(profile);

      if (result.success) {
        toast.success("Record saved successfully");
        uploadImage();
      } else {
        toast.error(result.errors);
      }
    } else {
      let result = await schoolApi.saveStaffMemberEditProfile(
        profile.id,
        selectedFiles,
        JSON.stringify(JSON.stringify(profile))
      );

      let data = await authApi.fetchMyImage();

      if (data) {
        blobToBase64(data).then((base64String) => {
          localStorage.setItem(
            "myimage",
            base64String.replace(/^data:image\/(png|jpg|jpeg);base64,/, "")
          );
        });
      } else {
        localStorage.setItem("myimage", "/img_avatar.png");
      }
      toast.success("Record updated successfully");
      uploadImage();
    }
  };

  const blobToBase64 = (blob) => {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const handlePhotoUpload = (event) => {
    setBody(URL.createObjectURL(event.target.files[0]));
    setSelectedFiles(event.target.files[0]);
  };

  const handleClose = () => {
    setUser({ password: "", confirmpassword: "" });
    setShow(false);
    setCheckPassword(true);
    setPasswordInputDisabled({
      password: false,
      confirmPassword: false,
    });
    setOldPassword();
    setPasswordError();
  };

  const handleChangeSubmit = async (e) => {
    console.log("oldPassword ==",oldPassword)
    console.log("checkOldPassword ==",checkOldPassword)
    console.log("user.password ==",user.password)

    setShow(true);
    e.preventDefault();

    if (!oldPassword) {
      return toast.error("Enter old password first");
    }
    if (checkOldPassword && !user.password) {
      return toast.error("Enter new password first");
    }
    if (checkOldPassword && !user.confirmpassword) {
      return toast.error("Enter confirm password first");
    }
    if (user.password === oldPassword) {
      return toast.error(
        "New password cannot be the same as the current password."
      );
    }

    if (Object.keys(passwordError).length > 0) {
      console.log("in return ")
      return toast.error("invalid password");
    }
    try {
      
   
    if (user.password === user.confirmpassword && user.password !== "") {
      console.log("success in")
      const obj = {
        id: profile.id,
        password: user.password,
      };
      console.log("obj == ",obj)
      const result = await schoolApi.updateProfile(obj);

      setShow(false);
      if (result?.success) {
        setPasswordInputDisabled({ password: false, confirmPassword: false });
        setUser({ password: "", confirmpassword: "" });
        toast.success(result.message);
      } else {
        toast.error(result?.message);
      }
      setCheckPassword(true);
      setOldPassword(null);
      setCheckOldPassword(null);
      setPasswordError();
    } else {
      if (user.password && user.confirmpassword) {
        setCheckPassword(false);
      }
    }
  } catch (error) {
      console.log("error->",error);
      toast.error("password not update")
  }
  };

  const handleImageUpload = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    const reader = new FileReader();
    reader.onloadend = () => {
      setImage(reader.result);
    };

    if (selectedFile) {
      reader.readAsDataURL(selectedFile);
    }
  };

  const uploadImage = async () => {
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append("image", file);
    const profileResult = await schoolApi.createFileForPublic(formData);
    if (profileResult.success === true) {
    } else {
    }
    return;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (oldPassword) {
        OldPasswordCheck(profile.id, oldPassword);
      } else {
        setCheckOldPassword(null);
        setPasswordInputDisabled((prev) => ({
          ...prev,
          password: true,
          confirmPassword: true,
        }));
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [oldPassword, profile.id]);

  const OldPasswordCheck = async (id, opassword) => {
    const result = await schoolApi.checkOldPassword(id, opassword);

    if (result.response) {
      setCheckOldPassword(result);
    } else {
      setCheckOldPassword();
    }
    if (result.response) {
      setPasswordInputDisabled((prev) => ({
        ...prev,
        password: false,
        confirmPassword: false,
      }));
    } else {
      setPasswordInputDisabled((prev) => ({
        ...prev,
        password: true,
        confirmPassword: true,
      }));
    }
  };

  const ChangePassword = async () => {
    setShow(true);
  };

  console.log('image-->',image);
  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <Row className="g-0">
        {}
        <Col lg={2} className="align-items-center d-flex justify-start mx-4">
          <Link className="nav-link" to="/">
            Home
          </Link>
          &nbsp;<i className="fa-solid fa-chevron-right"></i>&nbsp; Profile
        </Col>
        <Col lg={12} className="p-lg-3">
          <Container>
            <Row className="pt-4">
              <Col lg={1}></Col>
              <Col lg={3}>
                <Card>
                  <Card.Body className="text-center w-100">
                    <Card.Title style={{ textAlign: "center" }}>
                      {profile.firstname} {profile.lastname}
                    </Card.Title>

                    {image && (
                      <img
                        src={image}
                        alt="Profile Image"
                        onError={(e) => {
                          const alt = backendImageUrl(image);
                          if (alt && !e.target.dataset.retried && !/^(data:|blob:|https?:)/i.test(image)) {
                            e.target.dataset.retried = "1";
                            e.target.src = alt;
                          } else {
                            e.target.onerror = null;
                            e.target.src = "/img_avatar.png";
                          }
                        }}
                        style={{ maxWidth: "100%", width: "100%" }}
                      />
                    )}
                    <div className="">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageUpload}
                        className="mt-4 text-sm"
                      />
                    </div>
                    {/* <Button className="btn my-3 " variant="secondary" onClick={uploadImage} style={{ width: "100%", display: "block" }}>
                      Image Upload
                    </Button> */}

                    <Button
                      className="btn mt-3"
                      style={{ width: "100%", display: "block" }}
                      variant="danger"
                      onClick={() => {
                        ChangePassword();
                      }}
                    >
                      Change Password
                    </Button>
                    <input
                      onChange={handlePhotoUpload}
                      name="profilephotourl"
                      ref={fileInputRef}
                      type="file"
                      hidden
                    />
                  </Card.Body>
                </Card>
              </Col>

              <Col style={{ backgroundColor: "#fff" }} lg={7}>
                <Row className="view-form-header align-items-center">
                  <Col lg={6}>Edit Profile</Col>
                  <Col lg={6} className="d-flex justify-content-end">
                    {}
                    <Button className="btn-sm" onClick={handleSubmit}>
                      Save
                    </Button>
                  </Col>
                </Row>

                <Row className="pb-5 py-3">
                  <Col lg={6}>
                    <Form.Group className="mx-3 mb-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        First Name
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter First Name" //added by muskan khan 7 sept 2024
                        required //added by muskan khan 7 sept 2024
                        type="text"
                        name="firstname"
                        controlId="formBasicFirstName"
                        value={profile.firstname}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3 mb-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicLastName"
                      >
                        Last Name
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter Last Name" //added by muskan khan 7 sept 2024
                        required //added by muskan khan 7 sept 2024
                        type="text"
                        name="lastname"
                        controlId="formBasicLastName"
                        value={profile.lastname}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group className="mx-3 mb-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicLastEmail"
                      >
                        Email
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        controlId="formBasicLastEmail"
                        placeholder="Enter Email"
                        value={profile.email}
                        onChange={handleChange}
                        isInvalid={!!emailError}
                      />
                       <Form.Control.Feedback type="invalid">
                {emailError}
              </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3 mb-3">
                      <Form.Label className="form-view-label" htmlFor="formBasicPhone">
                        Phone
                      </Form.Label>
                      <Form.Control
                        type="phone"
                        name="phone"
                        controlId="formBasicPhone"
                        placeholder="Enter Phone"
                        value={profile.phone}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col lg={1}></Col>
            </Row>
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Change Password</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <Form>
                      <Row>
                        <Col className="mt-3">
                          <Form.Group className="mx-3">
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicOldPassword"
                            >
                              Old Password
                            </Form.Label>
                            <Form.Control
                              type="password"
                              name="oldpassword"
                              id="oldPassword"
                              placeholder="Enter Old password"
                              controlId="formBasicOldPassword"
                              value={oldPassword}
                              onChange={(e) => {
                                const trimmedValue = e.target.value.replace(
                                  /\s/g,
                                  ""
                                ); // Remove all spaces
                                setOldPassword(trimmedValue); // Update state without spaces
                              }}
                              required
                            />
                            {oldPassword ? (
                              checkOldPassword != null ? (
                                checkOldPassword ? (
                                  <span
                                    style={{
                                      color: "#2bd965",
                                      fontWeight: "600",
                                      paddingTop: "5px",
                                    }}
                                  >
                                    <i class="fa-regular fa-circle-check pt-1 px-1"></i>
                                    password match
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      color: "#f62b2b",
                                      fontWeight: "600",
                                      paddingTop: "5px",
                                    }}
                                  >
                                    <i class="fa-regular fa-circle-xmark"></i>
                                    Wrong Password
                                  </span>
                                )
                              ) : (
                                <span
                                  style={{
                                    color: "#f62b2b",
                                    fontWeight: "600",
                                    paddingTop: "5px",
                                  }}
                                >
                                  <i class="fa-regular fa-circle-xmark pt-1 px-1"></i>
                                  wrong password
                                </span>
                              )
                            ) : (
                              ""
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="mt-3">
                          <Form.Group className="mx-3">
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicNewPassword"
                            >
                              New Password
                            </Form.Label>
                            <Form.Control
                              type="password"
                              name="password"
                              placeholder="Enter New password"
                              value={user.password}
                              controlId="formBasicNewPassword"
                              onChange={handlePasswordOnchange}
                              disabled={passwordInputDisabled.password}
                              required
                            />
                            {passwordError ? (
                              <span
                                style={{
                                  // color: "#DC3545",
                                  // fontWeight: "600",
                                  // paddingTop: "5px",
                                  // fontSize: "6.90px",
                                  color: "#f62b2b",
                                  fontWeight: "600",
                                  paddingTop: "5px",
                                }}
                              >
                                {/* <i class="fa-regular fa-circle-check pt-1 px-1"></i> */}
                                {passwordError}
                              </span>
                            ) : (
                              ""
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="mt-3">
                          <Form.Group className="mx-3">
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicConfirmPassword"
                            >
                              Confirm Password
                            </Form.Label>
                            <Form.Control
                              type="password"
                              name="confirmpassword"
                              controlId="formBasicConfirmPassword"
                              value={user.confirmpassword}
                              disabled={passwordInputDisabled.confirmPassword}
                              placeholder="Enter Confirm Password"
                              onChange={handlePasswordOnchange}
                              required
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="ms-3">
                          {!checkPassword ? (
                            <span
                              style={{ color: "#f62b2b", fontWeight: "600" }}
                            >
                              <i class="fa-regular fa-circle-xmark"></i>{" "}
                              Passwords do not match.
                            </span>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                  <Col></Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={handleChangeSubmit}>
                  Save
                </Button>
                <Button variant="danger" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </Container>
        </Col>
        <Col lg={2}></Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};
export default Profile;